/* Controls inside the Bend Creator's steps, from the v15 prototype. Tokens come from the shell (`--bcs-*`). */

/* Bend Type: two columns of 100px tiles, each a line drawing and a name. */
.tiles {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.tile {
  min-height: 100px;
  padding: 12px 10px;
  background: #fff;
  border: 1px solid var(--bcs-border-control);
  border-radius: 8px;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  color: var(--bcs-gray-9);
  transition:
    background 100ms ease,
    border-color 120ms ease,
    box-shadow 120ms ease;

  &:active {
    background: var(--bcs-control-hover);
  }

  &[data-active] {
    border-color: var(--bcs-shop-primary);
    box-shadow: inset 0 0 0 1px var(--bcs-shop-primary);
    background: var(--mantine-primary-color-light);
    color: var(--bcs-shop-primary);
    font-weight: 600;
  }
}

.glyph {
  width: 64px;
  height: 32px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Bender: a small info box at the bottom of Dimensions that expands, in place, to 56px rows, one per bender profile. */
.benderBox {
  background: var(--bcs-gray-1);
  border: 1px solid var(--bcs-gray-2);
  border-radius: 8px;
  overflow: hidden;
}

.disclosure {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  font-size: 14px;
  transition: background 100ms ease;

  &:hover {
    background: var(--bcs-gray-2);
  }
}

.benderOptions {
  padding: 4px 10px 10px;
}

.disclosureText {
  flex: 1;
  min-width: 0;
  display: grid;
  gap: 2px;
}

.disclosureLabel {
  font-size: 13px;
  color: var(--bcs-gray-7);
}

.disclosureValue {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  color: var(--bcs-gray-9);
}

.disclosureChevron {
  flex: 0 0 auto;
  color: var(--mantine-color-gray-5);
  transition: transform 150ms ease;

  .disclosure[aria-expanded='true'] & {
    transform: rotate(90deg);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
}

.rows {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.row {
  width: 100%;
  min-height: 56px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  background: #fff;
  border: 1px solid var(--bcs-border-control);
  border-radius: 8px;
  transition:
    background 100ms ease,
    border-color 120ms ease,
    box-shadow 120ms ease;

  &:active:not(:disabled) {
    background: var(--bcs-control-hover);
  }

  &[data-active] {
    border-color: var(--bcs-shop-primary);
    box-shadow: inset 0 0 0 1px var(--bcs-shop-primary);
    background: var(--mantine-primary-color-light);
  }

  &:disabled {
    cursor: default;
    color: rgba(0, 0, 0, 0.35);
  }
}

.rowName {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 500;
}

.rowDetail {
  font-size: 13px;
  font-weight: 400;
  color: var(--bcs-gray-7);

  .row:disabled & {
    color: inherit;
  }
}

.sectionLabel {
  font-size: 14px;
  font-weight: 500;
  color: var(--bcs-gray-9);
}

/* Review: the bend's values, one row each. */
.spec {
  background: #fff;
  border: 1px solid var(--bcs-gray-2);
  border-radius: 8px;
  padding: 4px 14px;
}

.specRow {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 11px 0;
  border-bottom: 1px solid var(--bcs-gray-2);

  &:last-child {
    border-bottom: 0;
  }
}

.specLabel {
  flex: 1;
  font-size: 14px;
  color: var(--bcs-gray-7);
}

.specValue {
  font-family: var(--bcs-mono);
  font-size: 14px;
  font-weight: 500;
  color: var(--bcs-gray-9);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* A text field at the height of the other controls (56px), as in the prototype. */
.textInput {
  height: 56px;
  padding: 0 14px;
  font-size: 16px;
  border-color: var(--bcs-border-control);
  border-radius: 8px;
}
